<div class="contentArea" *ngIf="loadingHome">
    <div class="innerContainerReforma" *ngIf="showComponent">
        <div class="primaryContent">
            <ion-grid class="ion-no-padding" [ngClass]="showErrorScreen ? 'ion-hide' : ''">
                <ion-row>
                    <div class="container-header-beneficio">
                        <button type="button" class="btn-back" fill="clear" (click)="goBack()">
                            <ion-icon name="arrow-back-outline"></ion-icon>
                            <span>Volver</span>
                        </button>
                        <h2 id="statusElement" class="title-beneficios">
                            <strong>{{titleDetalleBeneficio}}</strong>
                        </h2>
                    </div>
                </ion-row>

                <ion-row>
                    <ng-container *ngIf="isBenefificarioSeleccionado('PGU')">
                        <div class="container-content-detalle-beneficio">
                            <ng-container *ngFor="let item of descripcionDetalleBeneficio">
                                <p *ngIf="item.type === 'text'">
                                    {{ item.content }}
                                </p>
                                <img *ngIf="item.type === 'imagen'" [src]="item.src" [alt]="" class="img-fluid my-3">
                            </ng-container>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="isBenefificarioSeleccionado('BAC') || isBenefificarioSeleccionado('CEV')">
                        <div class="container-content-detalle-beneficio-cotizaciones">
                            <p>
                                {{descripcionDetalleBeneficio[0].content}}
                            </p>
                            <br>

                            <div>
                                <p>{{ requisitos.length > 1 ? 'Requisitos:' : 'Requisito:' }}</p>
                                <ul>
                                    <li *ngFor="let item of requisitos">
                                        {{item}}
                                    </li>
                                </ul>
                            </div>

                            <ng-container *ngIf="descripcionDetalleBeneficio[1].type === 'imagen'">
                                <img [src]="getImagen(descripcionDetalleBeneficio[1].src, descripcionDetalleBeneficio[1].srcMobile)"
                                    [alt]="" class="img-fluid my-3">
                            </ng-container>

                            <app-card-importante [tipo]="tipoBeneficiosDetalle"
                                [urlCapitalPlay]="urlCapitalPlay"></app-card-importante>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="isBenefificarioSeleccionado('UF_RETIRO_PROGRAMADO')">
                        <div class="container-content-detalle-beneficio-uf">
                            <p>
                                {{descripcionDetalleBeneficio[0].content}}
                            </p>

                            <ng-container *ngIf="descripcionDetalleBeneficio[1].type === 'imagen'">
                                <img [src]="descripcionDetalleBeneficio[1].src" [alt]="" class="img-fluid my-3">
                            </ng-container>

                            <div>
                                <p>Requisitos para acceder al ajuste</p>
                                <ol>
                                    <li *ngFor="let item of requisitosAjuste">
                                        {{item}}
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </ng-container>
                </ion-row>

                <ion-row>
                    <app-faq-card #faqCard [tipoBeneficio]="tipoBeneficio" [faqs]="faqCardData" [titleFaq]="titleFaq"
                        [isReforma]="true" style="width: 100%;"></app-faq-card>
                </ion-row>
            </ion-grid>
        </div>
        <div class="secondaryContent" *ngIf="!showErrorScreen">
            <app-right-side-info-column [data]="rightColumnData" [isHelp]="true"
                (idRightColumnEmit)="idRightColumnEmit($event)"></app-right-side-info-column>
        </div>
    </div>
</div>